import { INTERESTS } from "../../Base/mappings";
import {
  buildAttachmentURL,
  buildYoutubeThumbURL,
  buildThumbURL,
  buildSpaceLogoURL,
  buildAudioAttachmentURL,
} from "../../../helpers/assets";
import { ATTACHMENT_TYPES } from "./types";

export const interestToRepresentation = (interest) => ({
  type: INTERESTS[interest.id],
  color: interest.background_color,
  name: interest.name,
  id: interest.id,
});

export const ownerToRepresentation = (owner) => ({
  followings: owner.user_followings.count,
  badges: owner.badges,
});

export const spaceToRepresentation = (space) => ({
  name: space.space_name,
  description: space.description,
  id: space.id,
  logo: buildSpaceLogoURL(
    space.id,
    space.logo_id,
    space.logo_image_type,
    space.logo_last_changed
  ),
  verified: space.is_verified,
  flags: space.flags
});

export const extendedSpaceToRepresentation = (space) => ({
  ...spaceToRepresentation(space),
  followers: space.followers_info.followers_count,
  socialScale: space.social_scale,
  postCount: space.posts_summary.count,
  lastPost: space.posts_summary.last_media_post,
});

export const postAwardsToRepresenation= (awards_summary)=>{
  return JSON.parse(JSON.stringify(awards_summary)); 
}
export const moderationSummaryToRepresenation= (awards_summary)=>{
  return JSON.parse(JSON.stringify(awards_summary)); 
}

export const postToRepresentation = (post) => ({
  id: post.id,
  content: post.contents,
  date: post.create_date,
  space: spaceToRepresentation(post.space),
  interest: interestToRepresentation(post.interest),
  og: post.og_tags,
  attachments: post.attachments.map((attachment) =>
    attachmentToRepresentation(post.id, attachment)
  ),
  isSharedPost: post.is_shared_post,
  place: post.place,
  awards: postAwardsToRepresenation(post.awards_summary),
  moderationStatus: post.moderation_status, 
  moderationSummary: moderationSummaryToRepresenation(post.moderation_summary), 
  sharedFrom: post.is_shared_post
    ? postToRepresentation(post.shared_from)
    : null,
  reactions: {
    likes: 1 in post.reactions ? post.reactions[1].degree_sum : 0,
    dislikes: 2 in post.reactions ? post.reactions[2].degree_sum : 0,
    comments: post.comments_count,
    shares: post.share_count,
  },
});

export const attachmentToRepresentation = (postID, attachment) => {
  let url = attachment.link;

  if (attachment.type == ATTACHMENT_TYPES.YOUTUBE) {
    url = buildYoutubeThumbURL(attachment.link);
  } else if (
    [ATTACHMENT_TYPES.VIDEO, ATTACHMENT_TYPES.GIF_IMAGE].includes(
      attachment.type
    )
  ) {
    url = buildThumbURL(
      postID,
      attachment.id,
      attachment.thumb_extension,
      attachment.thumb_path_hash
    );
  } else if (attachment.type == ATTACHMENT_TYPES.IMAGE) {
    url = buildAttachmentURL(
      postID,
      attachment.id,
      attachment.extension,
      attachment.url_path_hash
    );
  } else if (attachment.type == ATTACHMENT_TYPES.AUDIO) {
    url = buildAudioAttachmentURL();
  }
  return { ...attachment, url };
};
